import { useEffect, useRef } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "sonner";
import Nav from "@/components/Nav";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Manifesto from "@/components/Manifesto";
import Projects from "@/components/Projects";
import Photo from "@/components/Photo";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import Cursor from "@/components/Cursor";
import ProjectPage from "@/components/ProjectPage";
import ScrollProgress from "@/components/ScrollProgress";
import PageTransition from "@/components/PageTransition";
import BackToTop from "@/components/BackToTop";
import Admin from "@/components/Admin";
import { LanguageProvider } from "@/i18n/LanguageContext";

function Home({ onNavigate, lenisRef }) {
  return (
    <>
      <Nav onNavigate={onNavigate} />
      <main>
        <Hero onNavigate={onNavigate} />
        <Marquee />
        <Manifesto />
        <Projects />
        <Photo lenisRef={lenisRef} />
        <Contact />
      </main>
      <Footer onNavigate={onNavigate} />
      <BackToTop onNavigate={onNavigate} />
    </>
  );
}

function App() {
  const lenisRef = useRef(null);

  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, wheelMultiplier: 1 });
    lenisRef.current = lenis;
    window.__lenis = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  const scrollTo = (target) => {
    lenisRef.current?.scrollTo(target, { duration: 1.6, easing: (t) => 1 - Math.pow(1 - t, 4) });
  };

  return (
    <LanguageProvider>
      <div className="bg-[#050505] text-[#E5E5E5] min-h-screen" data-testid="app-root">
        <Cursor />
        <BrowserRouter>
          <ScrollProgress />
          <PageTransition />
          <Routes>
            <Route path="/" element={<Home onNavigate={scrollTo} lenisRef={lenisRef} />} />
            <Route path="/projet/:slug" element={<ProjectPage lenisRef={lenisRef} />} />
            <Route path="/admin" element={<Admin />} />
          </Routes>
        </BrowserRouter>
        <Toaster theme="dark" position="bottom-right" />
      </div>
    </LanguageProvider>
  );
}

export default App;
